import React from "react";
import { Link } from "react-router-dom";
import "./Deletion.css";

class Block extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			blockValue: Math.floor(Math.random() * 100),
			id: this.props.id,
		};
		this.onClicked = this.onClicked.bind(this);
	}

	onClicked() {
		let currBlockId = this.state.id;
		let elem = document.getElementById(currBlockId);
		elem.style.display = "none";
	}

	componentDidMount() {
		document.title = "Updation in Arrays | Array Bundle";
		window.scroll(0, 0);
	}

	render() {
		return (
			<div
				id={this.props.id}
				className="deletion-arr-block"
				onClick={this.onClicked}
			>
				{this.state.blockValue}
			</div>
		);
	}
}

let arr = [];

for (let i = 0; i < 10; i++) {
	arr.push(<Block id={"del_" + String(i)} />);
}

export default class Deletion extends React.Component {
	componentDidMount() {
		document.title = "Deletion in Arrays | Array Bundle";
		window.scroll(0, 0);
	}

	render() {
		return (
			<main>
				<div className="subbundle-main">
				<h1 style={{textAlign: 'center', fontFamily: 'Gilroy', textDecoration: 'underline', fontSize: '2rem'}}><Link to="/">Go to Home</Link></h1>
					<h1>Deletion in Arrays</h1>
					<p>
						Deletion in array means removing an element and
						replacing it with the next element or element present at
						next index. It involves three cases:
					</p>
					<p>
						<b>
							1. Element to be deleted at the beginning of the
							array <br />
							2. Element to be deleted at the end of the array{" "}
							<br />
							3. Element to be deleted at the given index{" "}
							<code>j</code> in the array
						</b>
					</p>
					<h2>Deletion for element at the beginning</h2>
					<img src="https://csveda.com/wp-content/uploads/2019/05/deletion-in-array-at-beginning.png" />
					<span>Deletion at the beginning</span>
					<p>
						In this case we have to move all the elements one
						position forward to fill the position of the element at
						the beginning of array. Though the deletion process is
						not difficult but moving all elements one position
						forward involve movement of all the existing elements
						except the one being deleted.
					</p>
					<p>
						This is the worst case scenario in deletion in a linear
						array. In the example array elements from index 1 to
						index 8 have to moved one position forwards so that the
						first element is replaced by second, second by third and
						so on
					</p>

					<h2>Deletion for element at the ending</h2>
					<img src="https://csveda.com/wp-content/uploads/2019/05/deletion-in-array-at-the-end.png" />
					<span>Deletion at the ending</span>
					<p>
						In this case we don’t have to move any elements since
						the action here will be just removing the last element.
						This is done by redefining the index of last element of
						linear array = N-1. This is the best case scenario in
						deletion in a linear array.
					</p>
					<p>
						In the example array no elements are moved. The last
						element is removed by setting the index of last element
						as 7.
					</p>

					<h2>
						Deletion for element at given index <code>j</code>
					</h2>
					<img src="https://csveda.com/wp-content/uploads/2019/05/deletion-in-array-at-given-position.png" />
					<span>Deletion at the index "j"</span>
					<p>
						Let J be any location in the array for one existing
						element. We have to delete the element at J position. To
						do this starting from J every element is moved one place
						forward so that the element after index J comes to
						position of Jth element. This is the average case
						scenario in deletion in linear array.
					</p>
					<p>
						In the example array ,elements from index J (4) to index
						8 have to moved one position forward so that an element
						at index 4 is replaced by element at index 5. Similarly
						element at 6th postion comes at 5th position, element at
						7th position comes at 6th position and element at 8th
						position replaces element at 7th position completing the
						deletion process
					</p>
					<img src="https://media.discordapp.net/attachments/877930443473846324/902142289512648744/unknown.png" />
					<span>Pseudocode for Deletion in Arrays</span>

					<hr />
					<h1>GAME TIME!</h1>
					<div className="subbundle-game-container">
						<h1>
							Delete the elements one by one, as you wish, until no element is left.
						</h1>
						<div className="deletion-arr-div">{arr}</div>
					</div>
					<div className="next-previous-div">
						<Link to="/games/arrays/updation">
							<span>
								{"<"}Prev <b>Updation in Arrays</b>
							</span>
						</Link>
					</div>
				</div>
			</main>
		);
	}
}
